// Expire any cookie whose name or value is not valid percent-encoding.
// Malformed cookies (e.g. a raw "%" left by an old popup cookie name) crash
// third-party scripts that decodeURIComponent over document.cookie, such as
// Shopify's storefront-banner.js ("URIError: URI malformed").
(function () {
  document.cookie.split('; ').forEach((pair) => {
    if (!pair) return;
    const eq = pair.indexOf('=');
    const name = eq > -1 ? pair.slice(0, eq) : pair;
    const value = eq > -1 ? pair.slice(eq + 1) : '';
    try {
      decodeURIComponent(name);
      decodeURIComponent(value);
    } catch (e) {
      const expiry = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
      document.cookie = `${name}=;${expiry};path=/`;
      document.cookie = `${name}=;${expiry}`;
    }
  });
})();

class popupForm {
  constructor() {
    this.popup = document.querySelector('[data-cc-popup]');
    this.klaviyoCompanyId = this.popup?.dataset.ccKlaviyoCompanyId || 'WPuDdH';
    this.klaviyoListId = this.popup?.dataset.ccKlaviyoListId || 'THnyVs';
    this.klaviyoSource = this.popup?.dataset.ccKlaviyoSource || 'First Orders 20% Off';
    this.contentEl = document.querySelector('.popup-form--content');
    this.form = document.getElementById('popup_email_signup');
    this.successEl = document.querySelector('.popup--success');

    this.qrMap = this.parseQrMap(this.popup?.dataset.ccQrCodes);
    this.isQrVisit = this.detectQrVisit();
    if (this.isQrVisit) this.applyQrDiscount();

    const submitBtn = document.querySelector('.popup-form-action--submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.submit();
      });
    }

    const consentCheckbox = document.getElementById('popupConsent');
    if (consentCheckbox && submitBtn) {
      consentCheckbox.addEventListener('change', () => {
        submitBtn.disabled = !consentCheckbox.checked;
      });
    }

    const phoneInput = document.getElementById('popupPhone');
    if (phoneInput) {
      phoneInput.addEventListener('input', (e) => {
        const raw = e.target.value;
        const hasPlus = raw.charAt(0) === '+';
        const digits = raw.replace(/\D/g, '');
        const cleaned = hasPlus ? '+' + digits : digits;
        if (cleaned !== raw) e.target.value = cleaned;
      });
    }

    document.querySelectorAll('[data-cc-copy-code]').forEach(btn => {
      btn.addEventListener('click', () => this.copyCode(btn));
    });
  }

  // A visit counts as a QR scan when the landing URL carries ?qr=<id> (or a
  // qr utm_source/utm_medium). Returns the QR id (string) or null. The id is
  // kept in sessionStorage so it survives navigation away from the landing page.
  detectQrVisit() {
    const params = new URLSearchParams(window.location.search);
    const utmSource = (params.get('utm_source') || '').toLowerCase();
    const utmMedium = (params.get('utm_medium') || '').toLowerCase();
    let qrId = null;
    if (params.has('qr')) {
      qrId = params.get('qr').trim() || 'default';
    } else if (utmSource === 'qr' || utmMedium === 'qr') {
      qrId = 'default';
    } else {
      // Shopify discount share links (gosweet.co.uk/discount/CODE) redirect
      // to the homepage with the code in a discount_code cookie rather than
      // the URL. A cookie code matching a configured QR line counts as a QR
      // visit; other discount codes (e.g. from email campaigns) don't.
      const cookieCode = this.getCookie('discount_code').trim().toLowerCase();
      if (cookieCode && this.qrMap) {
        qrId = Object.keys(this.qrMap).find(
          (id) => id === cookieCode || this.qrMap[id].code.toLowerCase() === cookieCode
        ) || null;
      }
    }
    try {
      if (qrId) {
        sessionStorage.setItem('cc-qr-visit', qrId);
      } else {
        qrId = sessionStorage.getItem('cc-qr-visit');
      }
    } catch (e) {
      // sessionStorage unavailable — fall back to the URL check only.
    }
    return qrId;
  }

  // Parses the "QR discount codes" theme setting: one QR code per line, in
  // the form "qr-id : CODE : amount : Klaviyo source" (all but the id
  // optional). A line holding just a code acts as its own id, so a bare
  // "JORDANLR10" line matches ?qr=jordanlr10 and shows JORDANLR10.
  parseQrMap(raw) {
    const map = {};
    (raw || '').split(/\r?\n/).forEach((line) => {
      const parts = line.split(':').map((p) => p.trim());
      if (!parts[0]) return;
      map[parts[0].toLowerCase()] = {
        code: parts[1] || parts[0],
        discount: parts[2] || '',
        source: parts[3] || ''
      };
    });
    return map;
  }

  getCookie(name) {
    const pair = document.cookie.split('; ').find((p) => p.indexOf(name + '=') === 0);
    if (!pair) return '';
    try {
      return decodeURIComponent(pair.slice(name.length + 1));
    } catch (e) {
      return '';
    }
  }

  applyQrDiscount() {
    const entry = this.qrMap[(this.isQrVisit || '').toLowerCase()];

    const qrCode = (entry && entry.code) || this.popup?.dataset.ccQrCode;
    if (!qrCode) return;

    document.querySelectorAll('[data-cc-copy-code]').forEach(btn => {
      btn.dataset.ccCopyCode = qrCode;
      btn.setAttribute('aria-label', `Copy discount code ${qrCode}`);
      const valueEl = btn.querySelector('.popup--discount-code-value');
      if (valueEl) valueEl.textContent = qrCode;
    });

    const qrDiscount = (entry && entry.discount) || this.popup.dataset.ccQrDiscount;
    const instructionsEl = document.querySelector('.popup--success-instructions');
    if (qrDiscount && instructionsEl && instructionsEl.dataset.ccInstructionsTemplate) {
      instructionsEl.textContent = instructionsEl.dataset.ccInstructionsTemplate.replace('[discount]', qrDiscount);
    }

    const qrSource = (entry && entry.source) || this.popup.dataset.ccKlaviyoQrSource;
    if (qrSource) this.klaviyoSource = qrSource;
  }

  copyCode(btn) {
    const code = btn.dataset.ccCopyCode;
    if (!code) return;
    navigator.clipboard.writeText(code).then(() => {
      btn.classList.add('copied');
      setTimeout(() => btn.classList.remove('copied'), 2000);
    });
  }

  setLoading(container, on) {
    if (!container) return;
    container.classList.toggle('active', on);
  }

  submit() {
    const emailInput = document.getElementById('popupEmail').value.trim();
    const phoneInput = document.getElementById('popupPhone').value.trim();
    const emailValidationEl = document.getElementById('popupEmail-validation');
    const phoneValidationEl = document.getElementById('popupPhone-validation');
    const errorEl = document.getElementById('popup-error');
    const buttonContainer = this.form.querySelector('.popup--button-container');

    const emailValid = this.validateEmail(emailInput);
    const phoneValid = this.validatePhone(phoneInput);

    emailValidationEl.classList.toggle('is-hidden', emailValid);
    phoneValidationEl.classList.toggle('is-hidden', phoneValid);
    if (!emailValid || !phoneValid) return;

    errorEl.classList.add('is-hidden');
    this.setLoading(buttonContainer, true);

    this.subscribe({ email: emailInput, phone_number: this.normalizePhone(phoneInput) })
      .then(ok => {
        this.setLoading(buttonContainer, false);
        if (!ok) {
          errorEl.classList.remove('is-hidden');
          return;
        }
        this.setCookie();
        this.showSuccess();
      })
      .catch(err => {
        console.error('Error submitting popup form:', err);
        this.setLoading(buttonContainer, false);
        errorEl.classList.remove('is-hidden');
      });
  }

  subscribe(attrs) {
    const options = {
      method: 'POST',
      headers: {
        revision: '2023-02-22',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            list_id: this.klaviyoListId,
            custom_source: this.klaviyoSource,
            properties: { newKey: '', ...(this.isQrVisit ? { qr_id: this.isQrVisit } : {}) },
            ...attrs
          }
        }
      })
    };

    return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.klaviyoCompanyId}`, options)
      .then(async response => {
        if (response.status === 202) return true;
        const errorBody = await response.text();
        console.error('Klaviyo subscription error:', response.status, errorBody);
        return false;
      });
  }

  showSuccess() {
    if (this.form) this.form.classList.add('is-hidden');
    if (this.successEl) this.successEl.classList.remove('is-hidden');
    if (this.contentEl) this.contentEl.classList.add('success');
  }

  setCookie() {
    if (!this.popup) return;
    const cookieName = this.popup.dataset.ccCookieName;
    if (!cookieName) return;
    const isLoggedIn = this.popup.dataset.ccLoggedIn === 'true';
    const cookieDuration = isLoggedIn ? 7 * 24 * 60 * 60 * 1000 : 1 * 24 * 60 * 60 * 1000;
    const expiry = new Date(Date.now() + cookieDuration);
    document.cookie = `${cookieName}=true;expires=${expiry.toUTCString()};path=/`;
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  validatePhone(phone) {
    return /^0\d{10}$/.test(phone) || /^\+\d{12}$/.test(phone);
  }

  normalizePhone(phone) {
    if (phone.charAt(0) === '+') return phone;
    if (phone.charAt(0) === '0') return '+44' + phone.slice(1);
    return phone;
  }
}

new popupForm();
